
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AboutUs extends Vue {
  version = "v2.1.16";
  cellList = [
    {
      title: "APP备案号",
      value: "粤ICP备20039181号-3A", // 粤ICP备20039181号-3A
      url: "openAppICP",
    },
    {
      title: "平台服务协议",
      value: "",
      url: "/userAgreement",
    },
    {
      title: "隐私协议",
      value: "",
      url: "/privacyPolicy",
    },
  ];

  mounted() {
    this.getAppData();
    this.refreshPage();
  }

  // 原生页面返回无感刷新方式
  refreshPage() {
    this.$bridge.registerHandler(
      "refreshPage",
      (data: string, responseCallback) => {
        // 获取版本
        this.getAppData();
      }
    );
  }

  // 获取版本
  getAppData() {
    this.$bridge.callHandler("getAppVersion", {}, (data: any) => {
      this.version = data;
    });
  }

  onCellItemClick(item, index) {
    const { url } = item;
    if (!url) return;
    if (index === 0) {
      this.$bridge.callHandler(url);
    } else {
      this.$router.push(`${url}?formPage=h5`);
    }
  }
}
